import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';
import MuiDivider from '@mui/material/Divider';
import { Link } from 'react-router-dom';

export const TooltipWrapper = styled('div')({
  width: '100%',
  textAlign: 'left',
  '& .events': {
    boxShadow: 'none'
  }
});

export const Divider = styled(MuiDivider)(({ theme }) => ({
  marginTop: theme.spacing(2)
}));

export const InfoCnt = styled('section')({
  flexWrap: 'wrap',
  padding: 0,
  display: 'flex',
  '& span, & svg': {
    verticalAlign: 'text-bottom',
    whiteSpace: 'nowrap'
  }
});

export const InfoSection = styled('section')({
  position: 'relative',
  display: 'flex',
  alignItems: 'center'
});

export const MeasurementsCtn = styled('div')(({ theme }) => ({
  flexWrap: 'wrap',
  width: '100%',
  padding: '0 32px 0px',
  display: 'flex',
  marginLeft: -6,
  [theme.breakpoints.down('md')]: {
    paddingLeft: 26,
    paddingRight: 0
  }
}));

export const LastLocationCtn = styled('div')(({ theme }) => ({
  padding: '0px 32px',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    paddingLeft: 26,
    paddingRight: 0
  }
}));

export const LinkStyleCtn = styled(Link)(({ theme }) => ({
  color: '#212121',
  paddingRight: theme.spacing(3),
  marginTop: 12,
  textDecoration: 'none',
  textAlign: 'center',
  display: 'flex',
  '&.alertColor': {
    color: '#f44336',
    '& span': {
      color: '#f44336',
      borderBottom: '1px #f44336 solid'
    }
  },
  '&.lightParam svg': {
    marginRight: 4
  },
  '&.pressureParam svg': {
    marginRight: 1
  }
}));

export const LinkStyle = styled('span')({
  color: '#212121',
  textDecoration: 'none',
  borderBottom: '1px #212121 solid',
  paddingTop: 3,
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    borderBottom: '1px transparent solid'
  }
});

export const ActiveInLink = styled(Link)({
  padding: 0,
  color: '#212121',
  textDecoration: 'none',
  borderBottom: '1px #212121 solid',
  paddingTop: 3,
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    borderBottom: '1px transparent solid'
  }
});

export const LinkStyleSecond = styled(Link)({
  fontSize: '0.875rem',
  color: '#0000008a',
  textDecoration: 'none',
  borderBottom: '1px #0000008a solid',
  paddingBottom: 1,
  margin: '0 16px -2px 0',
  '&:hover': {
    borderBottom: 'none'
  }
});

export const GreyText = styled(Typography)({
  fontSize: '0.875rem',
  color: '#0000008a'
});

export const DividerCtn = styled('div')({
  width: '100%',
  padding: '0px 28px'
});

export const ActiveInCnt = styled(Typography)({
  display: 'flex',
  flexWrap: 'wrap',
  padding: '8px 32px 0'
});

// Event styles
export const EventCnt = styled('div')({
  display: 'flex',
  minWidth: '150px',
  cursor: 'pointer',
  padding: '8px 0px 0px',
  margin: '0px 28px',
  '&:hover': {
    backgroundColor: 'transparent'
  }
});

export const EventIcon = styled('div')(({ theme }) => ({
  alignSelf: 'center',
  marginRight: theme.spacing()
}));

export const EventTitle = styled('div')({
  '& p:last-child': {
    color: '#212121',
    textDecoration: 'none',
    borderBottom: '1px #212121 solid',
    paddingTop: 3,
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      borderColor: 'transparent'
    }
  }
});

export const EventLink = styled(Link)({
  textDecoration: 'none',
  color: '#212121',
  display: 'flex'
});
